export const onlyUniqueStringsFilter = (
    value: string,
    index: number,
    array: string[]
) => {
    return array.indexOf(value) === index
}
